const {
  currentChars,
  arabicToPersian,
  numberToEnglish,
  seperateNumber,
  numberToWord,
  numberToWord_V2,
  numberToWord_V1,
  switchKey,
  halfSpace,
  compareWord,
} = require("./convert");
const {
  isPerstionLetterNumber,
  isPerstionLetter,
  isPerstionLetterSymbol,
  isPerstionLetterNumberSymbol,
  isFullName,
  isNumber,
  isDate,
  isTime,
  isDateTime,
  isTimeDate,
  isDayTime,
  isEmail,
  isAddress,
} = require("./dataValid");
const { nameInfo } = require("./name");
const {
  isNationalId,
  isNationalCode,
  generateNationalCode,
  generateNationalCodeRound,
  placeOfNationalCode,
} = require("./nationalIdCode");
const {
  shebaNumberInfo,
  bankNameCard,
  isShebaNumber,
  shebaIso7064Mod97,
} = require("./payment");
const { isPhoneNumber, phoneNumberInfo } = require("./phoneNumber");
const { isPlateNumber, plateNumberInfo } = require("./plateNumber");
const { postalCodeInfo } = require("./postalCode");

module.exports = {
  currentChars,
  arabicToPersian,
  numberToEnglish,
  seperateNumber,
  numberToWord,
  numberToWord_V2,
  numberToWord_V1,
  switchKey,
  halfSpace,
  compareWord,

  isPerstionLetterNumber,
  isPerstionLetter,
  isPerstionLetterSymbol,
  isPerstionLetterNumberSymbol,
  isFullName,
  isNumber,
  isDate,
  isTime,
  isDateTime,
  isTimeDate,
  isDayTime,
  isEmail,
  isAddress,

  isNationalId,
  isNationalCode,
  generateNationalCode,
  generateNationalCodeRound,
  placeOfNationalCode,

  shebaNumberInfo,
  bankNameCard,
  isShebaNumber,
  shebaIso7064Mod97,

  isPhoneNumber,
  phoneNumberInfo,

  isPlateNumber,
  plateNumberInfo,

  postalCodeInfo,
};
